module.exports = __webpack_public_path__ + "static/media/so-chic.03de1883.png";